"use strict";

exports.__esModule = true;
exports.default = isNull;
// Is a given value equal to null?
function isNull(obj) {
  return obj === null;
}